import styled, { css } from 'styled-components';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = styled(MuiAlert)`
  && {
    ${({ theme: { color, typography }, severity }) => {
      return css`
        background: #ffebea;
        align-items: center;
        border-radius: 4px;
        margin-bottom: 8px;

        &.MuiAlert-root {
          padding: 2px 12px;
        }

        .MuiAlert-message {
          ${({ theme: { font } }) => font.mainFont()};
          ${({ theme: { mui } }) => css`
            ${mui.breakpoints.down('sm')} {
              font-size: 12px;
            }
          `}
          font-size: 14px;
          line-height: 20px;
          justify-content: center;
          display: flex;

          strong {
            ${typography.nomalText()};
            color: ${color.red};
            font-weight: 700;
          }
        }

        .MuiIconButton-root {
          margin-bottom: 15px;
        }

        .MuiAlert-icon {
          margin-right: 10px;
          margin-top: 4px;
          align-self: flex-start;
        }

        .MuiAlert-action button svg > path {
          fill: #bac2cb;
        }
      `;
    }}
  }
`;

const ErrorMsg = styled.div`
  ${({ theme: { typography } }) => typography.smallText()}
`;

export { Alert, ErrorMsg };
